import type { ReactNode } from 'react';

import AboutMapSection from './AboutMapSection';
import AboutMilestonesSection from './AboutMilestonesSection';
import AboutPartnersSection from './AboutPartnersSection';
import AboutStrengthSection from './AboutStrengthSection';
import AboutVisual from './AboutVisual';
import AboutWhatWeDoSection from './AboutWhatWeDoSection';

type Props = {
  newsSection: ReactNode;
  phoneNumber: ReactNode;
};

export default function About({ newsSection, phoneNumber }: Props) {
  return (
    <>
      <AboutVisual />
      <AboutWhatWeDoSection />
      <AboutStrengthSection />
      <AboutPartnersSection />
      <AboutMilestonesSection />
      {newsSection}
      <AboutMapSection phoneNumber={phoneNumber} />
    </>
  );
}
